import React, { useEffect, useState } from "react";
import { Box, Badge, Typography, Menu, MenuItem, IconButton, Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { ReactComponent as NotificationIcon } from "@app/assets/Notification_Icon.svg";
import { ReactComponent as Toggle_on } from "@app/assets/Toggle_On.svg";
import { ReactComponent as Toggle_off } from "@app/assets/Toggle_Off.svg";
import useStyles from "./style";
import { RootState } from "@app/redux/store/root";
import { useDispatch, useSelector } from "react-redux";
import { seeNotification } from "@app/redux/actions/notifications";
import { ReactComponent as BellIcon } from "@app/assets/disable_notification.svg";
import { resetNoResultFound } from "@app/redux/actions/apps/actions";

const Notification = (props: any): JSX.Element => {
    const classes = useStyles();
    const history = useHistory();
    const dispatch: ThunkDispatch<RootState, void, Action> = useDispatch();
    const { notifications, appDetails }: any = useSelector((state: RootState) => state);
    const { setFilter, fetchMethod } = props;
    const [switchOn, setSwitchOn] = useState(false);
    const [allviewd, setAllViewd] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const [empty, setEmpty] = useState(false);

    useEffect(() => {
        if (notifications.data.earlier.length == 0 && notifications.data.todays.length == 0) {
            setEmpty(true);
        } else {
            setEmpty(false);
        }
        const unread = [...notifications.data.todays, ...notifications.data.earlier].find(
            (n) => n.read === false
        );
        if (unread) {
            setAllViewd(false);
        } else {
            setAllViewd(true);
        }
    }, [notifications, allviewd, empty]);

    const handleNotificationClick = async (notification: any) => {
        setAnchorEl(null);
        // api call to set notification seen
        if (!notification.read) {
            await dispatch(seeNotification([notification?.notification_id], true));
        }
        if (appDetails?.noResultFound) {
            dispatch(resetNoResultFound());
        }

        const type = notification?.type === "validation_report" ? "?type=validation_report" : "";
        history.push(`/developer/apps/${notification?.ValidationReport?.app_id}${type}`);
        await fetchMethod();
    };

    const toggleData = () => {
        setSwitchOn(!switchOn);
        setFilter({ read: switchOn ? "all" : "false" });
    };

    const allRead = async () => {
        setAllViewd(true);
        let ids = [
            ...notifications.data.todays.map((n: any) => {
                if (!n.read) return n.notification_id;
            }),
            ...notifications.data.earlier.map((n: any) => {
                if (!n.read) return n.notification_id;
            }),
        ];
        ids = ids.filter((i) => {
            return i !== undefined;
        });
        await dispatch(seeNotification(ids, true));
        await fetchMethod();
    };

    const Markunread = async (item: any) => {
        //
        await dispatch(seeNotification([item?.notification_id], false));
        await fetchMethod();
    };
    const MarkRead = async (item: any) => {
        await dispatch(seeNotification([item?.notification_id], true));
        await fetchMethod();
    };

    return (
        <div>
            <Box style={{ position: "relative" }}>
                <IconButton
                    onClick={handleClick}
                    aria-controls={open ? "notification-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                >
                    <Badge
                        overlap="rectangular"
                        className={classes.notificationCount}
                        badgeContent={notifications.unseenCount || 0}
                        color="secondary"
                    >
                        <NotificationIcon />
                    </Badge>
                </IconButton>
                {open ? <div className={classes.showTriangle}></div> : <></>}
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="notification-menu"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 0,
                }}
                PopoverClasses={{ paper: classes.paper }}
                MenuListProps={{ classes: { root: classes.notificationMenu } }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
                <Grid container style={{ paddingTop: "20px" }}>
                    <Grid item className={classes.notificationHeader} xs={6}>
                        Notifications
                    </Grid>
                    {(!empty || switchOn) && (
                        <Grid item className={classes.showReadOnlyText} xs={4}>
                            Show unread only
                        </Grid>
                    )}
                    {(!empty || switchOn) && (
                        <Grid item xs={2} onClick={() => toggleData()} className={classes.toggle}>
                            {switchOn ? <Toggle_on /> : <Toggle_off />}
                        </Grid>
                    )}
                </Grid>
                <hr className={classes.horizontalDivider} />
                {empty && (
                    <Grid
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justify="center"
                        className={classes.emptyBell}
                    >
                        <Grid item xs={3}>
                            <BellIcon />
                        </Grid>
                        <Typography className={classes.emptyNotifyText}>
                            No Notifications yet!
                        </Typography>
                        <Typography className={classes.emptyNotifySub}>
                            We’ll notify you when something arrives.
                        </Typography>
                    </Grid>
                )}
                {!empty && (
                    <Grid container className={classes.stickyHeader}>
                        <Grid className={classes.Latest} item xs={6}>
                            {notifications.data.todays.length > 0 ? "TODAY" : "EARLIER"}
                        </Grid>
                        {!allviewd && (
                            <Grid
                                onClick={() => allRead()}
                                className={classes.MarkRead}
                                item
                                xs={6}
                            >
                                Mark all as read
                            </Grid>
                        )}
                    </Grid>
                )}
                {!empty &&
                    notifications.data.todays.map((item: any) => {
                        return (
                            <MenuItem
                                className={`${classes.menuItem}`}
                                onClick={() => handleNotificationClick(item)}
                                classes={{ root: classes.notificationRow }}
                                key={item.notification_id}
                            >
                                <Grid container>
                                    <Grid item className={`${classes.notificationText}`} xs={9}>
                                        {item.message}
                                    </Grid>
                                    {item.read && (
                                        <Box
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                Markunread(item);
                                            }}
                                            className={classes.ellipseEmpty}
                                        ></Box>
                                    )}
                                    {!item.read && (
                                        <Box
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                MarkRead(item);
                                            }}
                                            className={classes.ellipse}
                                        ></Box>
                                    )}
                                    <Grid className={classes.hoursAgo} item xs={12}>
                                        {`${item.hours_ago},${new Date(item.created_at)
                                            .toLocaleDateString("en-US", {
                                                year: "numeric",
                                                month: "short",
                                                day: "numeric",
                                            })
                                            .replace(",", "")}`}
                                    </Grid>
                                </Grid>
                            </MenuItem>
                        );
                    })}
                {!empty && (
                    <Grid
                        item
                        xs={6}
                        className={`${classes.Latest}
                    ${
                        notifications.data.earlier.length > 0 &&
                        notifications.data.todays.length !== 0
                            ? `${classes.stickyHeader}`
                            : ``
                    }`}
                    >
                        {notifications.data.earlier.length > 0 &&
                            notifications.data.todays.length !== 0 &&
                            "EARLIER"}
                    </Grid>
                )}
                {!empty &&
                    notifications.data.earlier.map((item: any) => {
                        return (
                            <MenuItem
                                className={`${classes.menuItem}`}
                                onClick={() => handleNotificationClick(item)}
                                classes={{ root: classes.notificationRow }}
                                key={item.notification_id}
                            >
                                <Grid container>
                                    <Grid item className={`${classes.notificationText}`} xs={9}>
                                        {item.message}
                                    </Grid>
                                    {item.read && (
                                        <Box
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                Markunread(item);
                                            }}
                                            className={classes.ellipseEmpty}
                                        ></Box>
                                    )}
                                    {!item.read && (
                                        <Box
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                MarkRead(item);
                                            }}
                                            className={classes.ellipse}
                                        ></Box>
                                    )}
                                    <Grid className={classes.hoursAgo} item xs={12}>
                                        {`${new Date(item.created_at).toLocaleTimeString("en-US", {
                                            hour12: false,
                                            hour: "numeric",
                                            minute: "2-digit",
                                        })}, ${new Date(item.created_at)
                                            .toLocaleDateString("en-US", {
                                                year: "numeric",
                                                month: "short",
                                                day: "numeric",
                                            })
                                            .replace(",", "")}`}
                                    </Grid>
                                </Grid>
                            </MenuItem>
                        );
                    })}
                {!empty && <hr className={classes.horizontalDivider} />}
                {!empty && (
                    <Typography className={classes.notificationFooter}>
                        That’s all your notifications<br></br>
                        from the last 30 days.
                    </Typography>
                )}
            </Menu>
        </div>
    );
};

export { Notification };
